import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonFunctions } from '../static/common-functions';

export class InventoryQVBus extends BaseBus
{
    constructor(busObj: BaseBus = null) {
        super(busObj);
    }
    CID(): any {
        return this.id;
    }
    setId(id: any) {
        this.id = id;
    }
    initialize(data: InventoryQVBus) {
        super.initialize(data);
    }

    setBeforeSave() {

    }
    id: any;
    dispatchId: any;
    partType: string;
    quantity: number;
    usedPartQuantity: number;
    number: string;
    fullDescription: string;
    warehouse: string;
    isWrongPart: boolean;
    techId: any;
    orderId: any;
    orderNumber:string
    inventoryLocationId: any;
    fromInventoryLocationId: any;
    origUsedPartQuantity: number;
    inventoryBillingCodeId: any;
    isPart: boolean;
}
